import { mapState } from 'vuex';
import CONST from "@/utils/Constants";
import ApiHelper from '@/helpers/ApiHelper';
import LayoutTablet from "@/layouts/tablet/layout-tablet.vue"
import mLanguageSelect from "@/modules/m-language-select/m-language-select.vue"
import oButton from "@/objects/o-button/o-button.vue"

export default {
  name: "vStart",
  components: {
    "layout-tablet": LayoutTablet,
    "m-language-select": mLanguageSelect,
    "o-button": oButton
  },

  data() {
    return {}
  },

  computed: {
    ...mapState(['locale']),
    content() {
      return this.$store.getters.content;
    }
  },

  methods: {
    fetchData(locale) {
      ApiHelper
            .get(
              CONST.API.ROUTE.CONTENT + locale, { server: 'blockrocker_cms' }
            )
            .then((res) => {
              this.$store.commit('updateContent', { data: res.data.data, locale })
            })
    }
  },

  mounted() {
    this.fetchData('nl');
    this.fetchData('de');
    this.fetchData('en');
  }
}
